import React from 'react';
import Page1 from '../../components/admin/newAdd';
import Page2 from '../../components/admin/user';
import Page3 from "../../components/admin/Category";
import Count from "../../components/admin/Counts"


function Main() {
  return (
    <div className="flex flex-col">
      <div className='count'>
        <Count/>
      </div>
      <div className="MainDashboard flex flex-wrap gap-4  justify-between  items-center ">
        <div>
          <Page1 />
        </div>
        <div>
          <Page2 />
        </div>
        <div>
          <Page3 />
        </div>
      </div>
    </div>
  );
}

export default Main;
